import tracking from '@g4/g4-analytics';

export default (category, action, label) => {
  if (process.browser) {
    tracking.trackEvent(category, action, label);
  }
};
